import {AsyncInlineError, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

import {DomainSharedError} from '../../shared/Errors/DomainSharedError.js'
import {HttpSearchRepository} from '../Repositories/HttpSearchRepository.js'
import {RequestSearchValueObject} from '../ValueObjects/RequestSearchValueObject.js'

class GetResultsFromSearchUseCase extends UseCase {
  #config
  #repository

  constructor({config, repository}) {
    super()
    this.#config = config
    this.#repository = repository
  }

  static create({config}) {
    return new GetResultsFromSearchUseCase({
      config,
      repository: HttpSearchRepository.create({config})
    })
  }

  @tracer({metric: 'GetResultsFromSearchUseCase#execute'})
  @AsyncInlineError()
  async execute({listingSectionId, search} = {}) {
    try {
      const [error, response] = await this.#repository.getResultsFromSearch({
        config: this.#config,
        search: RequestSearchValueObject.createToApi({config: this.#config, listingSectionId, search})
      })

      return error
        ? Promise.reject(
            DomainSharedError.isDomainError({error})
              ? error
              : DomainSharedError.createGenericError({config: this.#config, cause: error})
          )
        : response
    } catch (error) {
      return Promise.reject(DomainSharedError.createGenericError({config: this.#config, cause: error}))
    }
  }
}

export const factory = GetResultsFromSearchUseCase.create
